export const FIND_MODULES_FAILURE = 'FIND_MODULES_FAILURE';

export const findModulesFailure = ({ error, request }) => ({
    type: FIND_MODULES_FAILURE,
    payload: error,
    error: true,
    meta: {
        request
    }
});